import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TextAreaFieldComponent } from 'src/app/components/form/textarea-field/textarea-field.component';

@Component({
  selector: 'activities-planning-postpone',
  imports: [ReactiveFormsModule, TextAreaFieldComponent],
  templateUrl: './activities-planning-postpone.component.html',
  styleUrl: './activities-planning-postpone.component.scss'
})
export class ActivitiesPlanningPostponeComponent implements OnChanges {

  @Input() postponedReason: string | null = null;
  @Input() disabled: boolean = false;
  @Output() onPostpone = new EventEmitter<string>();
  @Output() onPanelToggle = new EventEmitter<boolean>();

  isPanelOpen: boolean = false;
  postponedReasonControl: FormControl = new FormControl('', [Validators.required]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['postponedReason']) {
      this.postponedReasonControl.setValue(this.postponedReason ?? '', { emitEvent: false });
    }

    if (changes['disabled'] && this.disabled) {
      this.closePanel();
    }
  }

  togglePanel(): void {
    if (this.disabled) {
      return;
    }
    this.isPanelOpen = !this.isPanelOpen;
    this.onPanelToggle.emit(this.isPanelOpen);
  }

  save(): void {
    const reason = this.postponedReasonControl.value;

    if (!reason || !String(reason).trim()) {
      this.postponedReasonControl.markAsTouched();
      this.postponedReasonControl.setErrors({ required: true });
      return;
    }

    this.onPostpone.emit(String(reason).trim());
  }

  closePanel(): void {
    if (!this.isPanelOpen) {
      return;
    }
    this.isPanelOpen = false;
    this.onPanelToggle.emit(false);
  }
}
